<template>
  <div id="app" class="app">
    <navigation-com v-if="name"></navigation-com>
    <router-view class="wrapper" v-if="name"></router-view>
    <login-view v-if="!name && triedRestoreSession"></login-view>
    <div class="app-loader" v-if="!triedRestoreSession"></div>
  </div>
</template>

<script>
import NavigationCom from '@/components/Navigation'
import LoginView from '@/views/Login'

export default {
  components: {
    NavigationCom,
    LoginView
  },
  data () {
    return {
      triedRestoreSession: false
    }
  },
  computed: {
    name () {
      return this.$store.state.userInfo.name
    }
  },
  mounted () {
    setTimeout(() => {
      this.$http.get(
        'http://api.lootbox.se/restoresession',
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(({body}) => {
        this.triedRestoreSession = true

        if (!body) {
          return
        }

        this.$store.commit({
          type: 'userInfo',
          name: body.name,
          organisation: body.organisation
        })

        if (body.feeds.length) {
          this.$store.commit('feeds', body.feeds)
        }

        this.$store.commit('currentFeed', 0)

        console.log('Session restored!')
      }, () => {
        console.log('Fail!')
      })
    }, 1500)
  }
}
</script>

<style lang="sass">
@import './sass/core.sass'

+block('app')
  height: 100%
  width: 100%
  position: absolute

  +element('loader')
    width: 50px
    height: 50px
    background: rgba(0,0,0,.2)
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%) scale(.2)
    border-radius: 100%
    opacity: 0
    animation: load 1.5s infinite

@keyframes load
  75%
    opacity: 1
    transform: translate(-50%, -50%) scale(.8)

  100%
    opacity: 0
    transform: translate(-50%, -50%) scale(1)


+block('wrapper')
  overflow: scroll
  position: absolute
  height: 100%
  width: calc(100% - 285px) !important
  right: 0

</style>



// WEBPACK FOOTER //
// src/App.vue